import {
  PageSidebarContext,
  TypePageSidebarContextValue,
} from 'components/ui/layout/page/PageSidebarProvider';
import { useContext } from 'react';

export default function usePageSidebars(): TypePageSidebarContextValue {
  return useContext(PageSidebarContext);
}
